import { Facebook } from "lucide-react";
import { toast } from "sonner";

export default function ShareFacebookButton({ review, label = "Share on Facebook", testId = "share-facebook-button" }) {
  const handleShare = async () => {
    const bookUrl = `${window.location.origin}/books/${review.product_id}`;
    const shareUrl = `${process.env.REACT_APP_BACKEND_URL}/api/share/${review.product_id}`;
    const stars = "★".repeat(review.rating);
    const text = `${stars} My review of "${review.product_title}" by Michael Leckie:\n\n${review.text}\n\n${bookUrl}`;
    const popup = window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
      "fb-share",
      "width=640,height=560"
    );
    try {
      await navigator.clipboard.writeText(text);
      toast.success("Review copied — paste it into your Facebook post.");
    } catch {
      toast.info("Add your thoughts to the Facebook post before sharing.");
    }
    if (!popup) toast.error("Please allow pop-ups to share on Facebook.");
  };

  return (
    <button
      type="button"
      onClick={handleShare}
      data-testid={testId}
      className="inline-flex items-center gap-2 font-mono-ui text-[10px] uppercase tracking-[0.2em] text-soft hover:text-[#4c8dff] transition-colors"
    >
      <Facebook className="w-3.5 h-3.5" /> {label}
    </button>
  );
}
